<template>
  <div id="Competition" class="Competition">
    <v-dialog
      v-model="competitionDialog"
      persistent
      max-width="900"
      v-if="competionIsOver"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          small
          fixed
          fab
          bottom
          left
          dark
          v-on="on"
          class="pulse Competition__trigger"
        >
          <v-icon>mdi-license</v-icon>
        </v-btn>
      </template>
      <v-card class="Competition__cover" :class="{ part3: part3 }">
        <v-btn
          class="Competition__close"
          small
          color="red"
          fab
          @click="closeModal"
          ><v-icon color="white">mdi-close</v-icon></v-btn
        >

        <div class="Competition__coverInner">
          <!--
            <div class="Competition__half padding">
              <h1 class="Competition__title">My PA Box Virtual Walkthrough!⁣</h1>
              <p class="Competition__text text-center strong">
                Join us for a FREE virtual walkthrough of the My PA Box platform on April 11th, 2021 from 6 PM- 9 PM EST! We will provide insight on how to use My PA Box to enhance your PA school application process, tips & tricks for your personal statement, PA school interview advice, a CASPA walkthrough, and a question & answer session!⁣
              </p>
              <p class="Competition__text text-center">
                We will be joined by Kristy Goodman Chair of PA Admissions at Southern California University of Health Sciences Physician Assistant Program.
              </p>
              <p class="Competition__text text-center strong">
                ✨ONE LUCKY WINNER WILL BE REWARDED WITH A FREE BASIC PERSONAL STATEMENT REVISION!⁣✨
              </p>
              <p class="Competition__text text-center">
                  To secure your spot, register by filling out this form. You will receive an email inviting you to the zoom session the day before the event, April 10th. Max capacity will be 1,000 attendees!
              </p>

              <p class="Competition__textLink">
                <a
                  class="myPaBoxButton v-btn v-btn--depressed theme--light v-size--default info"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdkAZAEiSjOq2bn2BRAOW9BC4itbbksXhokpyD2GKMu9NumWw/viewform"
                >
                  <span class="v-btn__content"> Register Now! </span>
                </a>
              </p>
            </div>
            <div class="Competition__half">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdkAZAEiSjOq2bn2BRAOW9BC4itbbksXhokpyD2GKMu9NumWw/viewform"
              >
                <img
                  class="responsiveImage"
                  src="https://firebasestorage.googleapis.com/v0/b/production-7df26.appspot.com/o/WhatsApp%20Image%202021-04-02%20at%2017.04.17.jpeg?alt=media&token=d1547f15-14c3-48d6-a4f0-7344891f46bb"
                />
              </a>
            </div>
          -->

          <!--
            <div class="Competition__half padding">
              <h1 class="Competition__title">WE HAVE SOME EXCITING NEWS TO SHARE WITH YOU...⁣</h1>
              <p class="Competition__text">After many requests, we're thrilled to introduce the newest addition to myPAbox, our pre-PA services. ⁣</p>
              <p class="Competition__text">Designed to ease your application process, our services will provide you with expert opinions to guide you on your path from pre-PA to PA-C.⁣</p>
              <ul>
                <li> 𝐌𝐎𝐂𝐊 𝐈𝐍𝐓𝐄𝐑𝐕𝐈𝐄𝗪𝐒⁣ </li>
                <li> 𝐏𝐄𝐑𝐒𝐎𝐍𝐀𝐋 𝐒𝐓𝐀𝐓𝐄𝐌𝐄𝐍𝐓 𝐑𝐄𝐕𝐈𝐒𝐈𝐎𝐍⁣ </li>
                <li> 𝐒𝐔𝐏𝐏𝐋𝐄𝐌𝐄𝐍𝐓𝐀𝐋 𝐄𝐒𝐒𝐀𝐘 𝐑𝐄𝐕𝐈𝐒𝐈𝐎𝐍⁣ </li>
              </ul>
              <p class="Competition__textLink">
                <a href="https://mypabox.com/services">mypabox.com/services</a>
              </p>
            </div>
          -->
          <div class="Competition__full">
            <a href="https://www.mypabox.com/services">
              <img class="responsiveImage" src="@/assets/paBoxServices2.jpg" />
            </a>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      showAll: false,
      competionIsOver: false,
      competitionDialog: false,
      part1: true,
      part2: false,
      part3: false
    };
  },
  methods: {
    readAllShow() {
      console.log("aaa");
      this.showAll = true;
    },
    showStep(event) {},
    goBack() {
      this.part1 = true;
      this.part2 = false;
      this.part3 = false;
    },
    closeModal() {
      this.competitionDialog = false;
      this.goBack();
    },
    checkTheTiming() {
      const now = new Date().getTime();
      const end = new Date("December 31, 2028 23:59:00").getTime();
      const days = end - now;
      /*
      var offset = new Date().getTimezoneOffset();// getting offset to make time in gmt+0 zone (UTC) (for gmt+5 offset comes as -300 minutes)
      var date = new Date();
      date.setMinutes ( date.getMinutes() + offset);// date now in UTC time
      var easternTimeOffset = -240; //for dayLight saving, Eastern time become 4 hours behind UTC thats why its offset is -4x60 = -240 minutes. So when Day light is not active the offset will be -300
      date.setMinutes ( date.getMinutes() + easternTimeOffset);
      */

      return days > 0 ? true : false;
    },
    checkTheSessionStorage() {
      const showPopup = sessionStorage.getItem("showPopupAnnouncement");
      if (showPopup === null) {
        sessionStorage.setItem("showPopupAnnouncement", "true");
        return true;
      } else {
        return false;
      }
    },
    toShowPopup() {
      return this.checkTheSessionStorage() && this.checkTheTiming();
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.competionIsOver = this.checkTheTiming();
    this.competitionDialog = this.toShowPopup();
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap");

h1,
h2,
h3,
h4,
p,
div {
  font-family: "Poppins", sans-serif;
}

.Competition__cover {
  position: relative;
}

.Competition__cover .myPaBoxButton {
  background-color: #191340 !important;
  border-color: #191340 !important;
}
.Competition__cover .strong {
  font-weight: bold;
}
.Competition__half.padding {
  padding: 24px;
}
.Competition__close {
  position: absolute;
  right: 20px;
  top: 20px;
}

.responsiveImage {
  width: 100%;
  display: block;
}

.Competition__title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 16px;
  line-height: 1.2;
}

.Competition__text {
  font-size: 14px;
}

.Competition__textLink {
  font-size: 14px;
  text-align: center;
  color: #191340;
  margin-top: 16px;
}

.Competition__half {
  width: 100%;
}

.Competition__coverInner {
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
}

@media (min-width: 768px) {
  .Competition__title {
    font-size: 20px;
  }
  .Competition__coverInner {
    flex-direction: row;
  }
  .Competition__full {
    width: 100%;
  }
  .Competition__half {
    width: 50%;
  }
  .Competition__text {
    font-size: 12px;
  }
}
@media (min-width: 900px) {
  .Competition__title {
    font-size: 24px;
  }
  .Competition__text {
    font-size: 14px;
  }
}
@media (max-width: 900px) {
  .Competition__trigger {
    bottom: 65px !important;
  }
}
/* .Competition__cover.part3 {
    min-height: 80vh;
    max-height: 700px;
  }

  .Competition__coverPart3 {
    position: absolute;
    top: 70px;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .Competition__coverPart3 iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }

  .Competition__coverPart3 .Competition__back {
    top: -50px;
  }

  .Competition__title {
    text-align: center;
    color: #191340;
  }

  .Competition__titlesub,
  .Competition__titleHash {
    text-align: center;
    color: #191340;
    margin: 30px 0;
  }

  .Competition__titleMini {
    color: #191340;
    margin: 20px 0 0;
  }

  .Competition__close,
  .Competition__back {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .Competition__back {
    right: auto;
    left: 20px
  }

  .Competition__description {
    text-align: center;
    font-size: 12px;
    margin: 20px 0 0;
  }

  @media (max-width: 900px) {
    .Competition__trigger {
      bottom: 65px !important;
    }

    .Competition__titleHash {
      font-size: 20px;
    }
    .Competition__cover {
      padding: 60px 20px;
    }
  }
  @-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  .pulse {
    -webkit-animation: pulse ease-in-out 4s infinite 1s;
            animation: pulse ease-in-out 4s infinite 1s;
  } */
</style>



// WEBPACK FOOTER //
// src/components/User/Announcement.vue